export function checkAccess(auth, role, permission) {
  const rolesByName = auth?.user?.rolesByName?.[auth?.user?.user?.actualOrganizationalUnitId];

  if (permission) {
    return (rolesByName?.[role] || {})[permission] || (auth?.user?.permissions || {})[permission];
  } else {
    return !!rolesByName?.[role];
  }
}
